module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhBAMAAADMnc9JAAAALVBMVEXyUCLyTh/zVy3///+EvRZ/ugDyTBvzXziJvyQWp/Akq/D/viT/uxYApO//uQCG/j5fAAAAtklEQVR4AWIgBzAqG4OAaygZIADQ3hzBAAiEARQ+tyRfDm35FuTubrnlEsW5S5Cv5dKWQ45t5/S3nfQ9f/t+KhKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIrEKVH8Sm0hjFqchUJ+6wrVEIpFYVFwirXnejkB7uiLNWTyfQDeRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJZcQXRAKMZlIWTi8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sso/ms-icon.png
// module id = 1800
// module chunks = 0